import {
  CARD_CODES,
  CARD_LOGIN_TYPE_BY_ORGANIZATION_CODE,
  CardCodes,
  CardLoginType,
  OrganizationCodes,
} from '@revenuemarket/bank';
import { Drawer } from 'antd';

import { CardLoginByCertificate } from './CardLoginByCertificate';
import { CardLoginByID } from './CardLoginByID';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  organizationCode: OrganizationCodes;
  initScrape: boolean;
  onChangeOrganizationCode: (organizationCode: CardCodes) => void;
}

export const CardOrganizationConnectDrawer: React.FC<Props> = ({
  isOpen,
  onClose,
  organizationCode,
  initScrape,
  onChangeOrganizationCode,
}) => {
  const loginType =
    CARD_LOGIN_TYPE_BY_ORGANIZATION_CODE[
      organizationCode as keyof typeof CARD_LOGIN_TYPE_BY_ORGANIZATION_CODE
    ][0];
  const organizationName = CARD_CODES[organizationCode as CardCodes];
  return (
    <Drawer placement="right" title={`${organizationName} 로그인`} open={isOpen} onClose={onClose}>
      {loginType === CardLoginType.LOGIN_ID ? (
        <CardLoginByID
          organizationCode={organizationCode}
          onSuccess={onClose}
          onClose={onClose}
          onChangeOrganizationCode={onChangeOrganizationCode}
        />
      ) : (
        <CardLoginByCertificate
          initScrape={initScrape}
          organizationCode={organizationCode}
          onSuccess={onClose}
          onLoginTypeChange={onClose}
        />
      )}
    </Drawer>
  );
};
